import { type RefObject, useEffect, useMemo, useState } from 'react';

import { fg } from '@atlaskit/platform-feature-flags';

type UseIsInViewportProps = {
	ref: RefObject<HTMLElement>;
	rootMargin?: string;
};

export const useInViewport = ({ ref, rootMargin = '0px 0px 200px 0px' }: UseIsInViewportProps) => {
	const [isInViewport, setIsInViewport] = useState(false);

	const observer = useMemo(
		() =>
			new IntersectionObserver(
				([entry]) => {
					if (entry.isIntersecting && !fg('navx-2558-fix-sidenav-viewed-event')) {
						setIsInViewport(entry.isIntersecting);
					}
					setIsInViewport(entry.isIntersecting);
				},
				{
					rootMargin,
				},
			),
		[rootMargin],
	);

	useEffect(() => {
		if (ref.current) {
			observer.observe(ref.current);
			return () => observer.disconnect();
		}
	}, [observer, ref]);

	return {
		isInViewport,
	};
};
